import * as R from "ramda";

export const toString = x => (typeof x === "string" ? x : R.toString(x));

export const getItemId = item =>
  toString(item.variants ? item.variants[0].id : item.id);
